import React from 'react';
import { Box } from '@mui/material';
import { BrandLockup } from './BrandLockup';
import { radius, shadow } from '../theme/tokens';

interface CenteredAuthCardProps {
  children: React.ReactNode;
}

/**
 * Full-page centred card chrome for auth state pages.
 * Brand lockup pinned to the top; card centred in the viewport.
 */
export function CenteredAuthCard({ children }: CenteredAuthCardProps) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 24,
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <BrandLockup size={28} />
      </Box>
      <Box
        sx={{
          width: 400,
          maxWidth: '100%',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: `${radius.lg}px`,
          boxShadow: (theme) =>
            theme.palette.mode === 'dark' ? shadow.dark.pop : shadow.light.pop,
          p: '32px 32px 28px',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
